import { render } from "./parentsProfile.vue?vue&type=template&id=274f709a&scoped=true"
import script from "./parentsProfile.vue?vue&type=script&lang=js"
export * from "./parentsProfile.vue?vue&type=script&lang=js"

import "./parentsProfile.vue?vue&type=style&index=0&id=274f709a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274f709a"]])

export default __exports__